import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { postSurveyData } from '../../services/api';

class TwoOption extends React.PureComponent {
    static propTypes = {
        surveyId: PropTypes.string,
        votecount: PropTypes.number,
        isExpire: PropTypes.bool,
        resultShow: PropTypes.bool,
        content: PropTypes.object,
    };

    state = {
        itemid: '',
        resultShow: this.props.resultShow,
        votecount: this.props.votecount,
    };

    handleSubmit = async itemid => {
        const {
            surveyId,
            votecount,
            content: { questionid },
        } = this.props;

        const survey = await postSurveyData(`sur[${questionid}][]=${itemid}`, surveyId);

        this.setState({
            itemid,
            resultShow: true,
            votecount: votecount + 1,
        });

        window.alert(survey.msg);
    };

    render() {
        const { itemid, resultShow, votecount } = this.state;
        const {
            isExpire,
            content: { question, option },
        } = this.props;

        return (
            <div className={styles.box}>
                <div className={styles.title}>{question}</div>
                {resultShow ? (
                    <div className={styles.result}>
                        <div className={styles.result_item}>
                            <span>
                                <span>{option[0].title.slice(0, 12)}</span>
                                {itemid === option[0].itemid && <span className={styles.icon_0} />}
                            </span>
                            <span>
                                <span>{option[1].title.slice(0, 12)}</span>
                                {itemid === option[1].itemid && <span className={styles.icon_1} />}
                            </span>
                        </div>
                        <div className={styles.bar}>
                            <span style={{ width: `${option[0].nump - 0.25}%` }} />
                            <span style={{ width: `${option[1].nump - 0.25}%` }} />
                        </div>
                        <div className={styles.count}>
                            <span>{itemid === option[0].itemid ? option[0].num + 1 : option[0].num} 人</span>
                            <span>{itemid === option[1].itemid ? option[1].num + 1 : option[1].num} 人</span>
                        </div>
                    </div>
                ) : (
                    <div className={styles.option}>
                        <span className={styles.item_0} onClick={() => this.handleSubmit(option[0].itemid)}>
                            <span>{option[0].title}</span>
                        </span>
                        <span className={styles.vs} />
                        <span className={styles.item_1} onClick={() => this.handleSubmit(option[1].itemid)}>
                            <span>{option[1].title}</span>
                        </span>
                    </div>
                )}
                <div className={styles.tips}>
                    <span>{`${votecount}人参与`}</span>
                    <span>{isExpire ? '抱歉，本调查已经结束' : '投票进行中'}</span>
                </div>
            </div>
        );
    }
}

export default TwoOption;
